// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(31, 91, 64, 0.04)',
          borderTop: '1px solid',
          borderTopColor: 'rgba(31, 91, 64, 0.08)',
          borderBottom: '2px solid',
          borderBottomColor: 'rgba(31, 91, 64, 0.1)',
          '& .MuiTableCell-head': {
            fontWeight: 700,
            fontSize: '0.6875rem',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: theme.vars.palette.text.secondary,
            whiteSpace: 'nowrap'
          }
        }
      }
    }
  };
}
